import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const BroomIcon = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      stroke="#0058AD"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M10 7.333H8.271A2 2 0 0 0 6.319 8.9l-.986 4.434h3.334m1.333-6h1.22a2 2 0 0 1 1.996 2.111l-.163 2.945a1 1 0 0 1-.999.944H8.667m1.333-6v-.666m-1.333 6.666.666-2.666M10 2v4.667m0 0H8.667m1.333 0h1.333M3 13.333 2 12m1.333-2-1-1.333"
    />
  </Svg>
);

export default BroomIcon;
